"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tree_1 = require("./utils/tree");

var Entry =
/*#__PURE__*/
function () {
  function Entry(value, revision) {
    _classCallCheck(this, Entry);

    this.value = value;
    this.revision = revision || 0;
  }

  _createClass(Entry, [{
    key: "isValid",
    get: function get() {
      return true;
    }
  }]);

  return Entry;
}();

var Tombstone =
/*#__PURE__*/
function () {
  function Tombstone(revision) {
    _classCallCheck(this, Tombstone);

    this.revision = revision;
  }

  _createClass(Tombstone, [{
    key: "isValid",
    get: function get() {
      return false;
    }
  }]);

  return Tombstone;
}();

var Cache =
/*#__PURE__*/
function () {
  function Cache() {
    _classCallCheck(this, Cache);

    this.items = new tree_1.TreeMap();
  }

  _createClass(Cache, [{
    key: "store",
    value: function store(key, value, revision) {
      var entry = this.items.get(key);

      if (entry && entry.revision > revision) {
        if (entry.isValid) {
          return entry.value;
        }

        return null;
      }

      this.items.set(key, new Entry(value, revision));
      return value;
    }
  }, {
    key: "delete",
    value: function _delete(key, revision) {
      var curr = this.items.get(key);

      if (!curr || curr.revision < revision) {
        this.items.set(key, new Tombstone(revision));
      }
    }
  }, {
    key: "isKnown",
    value: function isKnown(key, revision) {
      var curr = this.items.get(key);
      return curr && curr.revision >= revision;
    }
  }, {
    key: "get",
    value: function get(key) {
      var entry = this.items.get(key);

      if (entry && entry.isValid) {
        return entry.value;
      }

      return null;
    }
  }, {
    key: "has",
    value: function has(key) {
      var entry = this.items.get(key);
      return entry && entry.isValid;
    }
  }]);

  return Cache;
}();

exports.Cache = Cache;
exports["default"] = Cache;